import type { LanguageEnum, LanguageLocalesEnum } from 'js/src/client';
import type { ReadonlySupportedLanguage } from 'js/src/data/translations/translations-types';

export function convertLocaleToLanguageCode(
    supportedLanguages: readonly ReadonlySupportedLanguage[],
    localeOrLang: LanguageEnum | LanguageLocalesEnum,
): LanguageEnum | undefined {
    const matchingLanguage = supportedLanguages.find(
        (lang) =>
            lang.code === localeOrLang ||
            lang.translation_locales?.some((locale) => locale.code === localeOrLang),
    );
    return matchingLanguage?.code;
}
